import React from 'react';
import PropTypes from 'prop-types';
import { st, classes } from './Footnote.st.css.js';
import Divider from '../../../Divider';
import { useBaseModalLayoutContext } from '../../BaseModalLayoutContext';
export const Footnote = ({ dataHook, className, children, skin = 'neutral', }) => {
    const { footnoteClassName, footnote = children } = useBaseModalLayoutContext();
    return ((footnote && (React.createElement("div", { "data-hook": dataHook, className: st(classes.root, {
            skin,
        }, footnoteClassName, className) },
        React.createElement(Divider, null),
        React.createElement("div", { className: classes.innerContent }, footnote)))) ||
        null);
};
Footnote.displayName = 'BaseModalLayout.Footnote';
Footnote.propTypes = {
    className: PropTypes.string,
    dataHook: PropTypes.string,
    footnote: PropTypes.node,
    skin: PropTypes.oneOf(['neutral', 'light']),
};
//# sourceMappingURL=Footnote.js.map